module.exports = __webpack_public_path__ + "img/1_005.31c55ca3.jpg";